@import 'styles/mixins';
@import 'styles/blaze/mixins';

.options {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: flex-start;
  align-content: flex-start;
  gap: 15px;
  align-self: stretch;
  flex-wrap: wrap;
  margin-top: 10px;
  width: 100%;

  @include for-phone-only {
    grid-template-columns: 1fr 1fr;
    margin-bottom: 150px;
  }
}

.emoji {
  font-size: 24px;
}

.container {
  padding-left: 35px;
  padding-right: 35px;
  margin: 0 auto;
  margin-top: 50px;
  width: 100%;

  @include for-phone-only {
    margin-top: 36px;
    padding: 0;
  }
}

.icon {
  position: absolute;
  right: -8px;
  bottom: -15.5px;
  font-size: 44px;
}

.cardButton {
  height: 75px;

  @include for-phone-only {
    height: 52px;
  }
}

.cardButtonLabel {
  font-weight: 400 !important;
  font-size: 16px !important;
}

.fieldsContainer {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 25px;

  @include for-desktop-only {
    gap: 40px;
    width: 450px;
    margin: 0 auto -50px auto;
  }
}

.fieldGroup {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  width: 100%;
}

.selectCategory {
  @include md-sohne;
  border-radius: 10px;
  border: 1px solid var(--dark-8);
  background: var(--light-100);
  padding: 12px;
  gap: 6px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  height: 48px;

  @include for-phone-only {
    height: 44px;
  }

  &.forStrategies {
    height: 48px;
    padding: 12px 15px;
  }
}

.menuItem {
  display: flex;
  align-items: center;
  gap: 8px;
}

.businessTypePopover {
  width: 450px;
  min-width: 450px;
  max-width: 450px;

  @include for-phone-only {
    width: 100%;
    min-width: 0;
    max-width: min(450px, calc(100vw - 24px));
  }
}

.errorMessage {
  margin: 0;
}

.customInputContainer {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 15px;
  width: 100%;

  label {
    display: block;
    text-align: left;
  }
}

.drawerContent {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 100%;

  label {
    display: block;
  }

  input {
    margin-bottom: 20px;
  }
}

.strategiesContainer {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100dvh;
  width: 100vw;
  background-color: var(--light-100);
  padding-top: 30px;

  @include for-phone-only {
    padding-top: 64px;
  }

  .leftSide {
    height: 100%;
    min-width: 50%;
    width: 100%;

    .leftContent {
      display: flex;
      flex-direction: column;
      justify-content: center;
      justify-self: center;
      align-items: flex-start;
      height: 100%;
      gap: 30px;
      width: 420px;
      margin: 0 auto;

      .top {
        display: flex;
        flex-direction: column;
        justify-content: center;
        justify-self: center;
        align-items: flex-start;
        width: 100%;
        gap: 30px;
      }

      @include for-small-desktop-down {
        align-items: center;
      }

      @include for-phone-only {
        width: 100%;
        padding: 16px;
        justify-content: space-between;
        gap: 25px;
        overflow: auto;
        height: calc(100dvh - 64px);
        padding-bottom: 16px;

        .fieldGroup {
          padding: 0 4px;
        }

        .texts {
          text-align: center;
          align-items: center;
          padding: 0 4px;

          h1 {
            text-align: center;
          }
        }
      }

      .texts {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;

        h1 {
          text-align: start;
        }
      }

      .fieldGroup {
        width: 325px;

        @include for-small-desktop-down {
          width: 100%;
        }
      }
    }
  }
}

.blazeIllustration {
  /* stylelint-disable-next-line scss/media-feature-value-dollar-variable */
  @include for-small-desktop-down {
    display: none;
  }

  @include for-small-desktop-up {
    height: calc(100% - 50px);
    margin-right: 24px;
    object-fit: contain;
    aspect-ratio: 549/690; // Prevent CLS while image loads
    max-width: calc(100% - 450px);
  }
}

.popover {
  width: 325px;
  min-width: 325px;
  max-width: 325px;

  @include for-phone-only {
    width: 100%;
    min-width: 0;
    max-width: min(325, calc(100vw - 24px));
  }
}
